var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12 4.00073C7.59 4.00073 4 7.59073 4 12.0007C4 16.4107 7.59 20.0007 12 20.0007C16.41 20.0007 20 16.4107 20 12.0007C20 7.59073 16.41 4.00073 12 4.00073ZM16 14.5907L14.59 16.0007L12 13.4107L9.41 16.0007L8 14.5907L10.59 12.0007L8 9.41073L9.41 8.00073L12 10.5907L14.59 8.00073L16 9.41073L13.41 12.0007L16 14.5907Z",
    fill: "#858585"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.59 8.00073L12 10.5907L9.41 8.00073L8 9.41073L10.59 12.0007L8 14.5907L9.41 16.0007L12 13.4107L14.59 16.0007L16 14.5907L13.41 12.0007L16 9.41073L14.59 8.00073ZM12 2.00073C6.47 2.00073 2 6.47073 2 12.0007C2 17.5307 6.47 22.0007 12 22.0007C17.53 22.0007 22 17.5307 22 12.0007C22 6.47073 17.53 2.00073 12 2.00073ZM12 20.0007C7.59 20.0007 4 16.4107 4 12.0007C4 7.59073 7.59 4.00073 12 4.00073C16.41 4.00073 20 7.59073 20 12.0007C20 16.4107 16.41 20.0007 12 20.0007Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.72ea64c20e23c29db8d831e51c8b08b0.svg";
export { ForwardRef as ReactComponent };